export function Immunity(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 0C2.68629 0 0 2.68629 0 6V18C0 21.3137 2.68629 24 6 24H18C21.3137 24 24 21.3137 24 18V6C24 2.68629 21.3137 0 18 0H6ZM13.5391 15.9641C13.5391 17.0266 13 17.6203 12.0156 17.6203C11.0156 17.6203 10.4531 17.0188 10.4531 15.9641V8.45625C10.4531 7.39375 11.0078 6.8 11.9922 6.8C12.9844 6.8 13.5391 7.40157 13.5391 8.45625V15.9641Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
